import React from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  children?: React.ReactNode

  infos?: React.ReactNode | string
  colors?: { main: string; sub: string; cover: string }
}

export const Quote = ({
  children,
  infos,
  colors = { main: '#000', sub: '#aaa', cover: '#fff' }
}: Props) => (
  <div className='Quote'>
    <div className='quote' style={{ color: colors.main }}>
      {children && children}
    </div>
    {infos && (
      <div className='infos' style={{ color: colors.sub }}>
        {infos}
      </div>
    )}
  </div>
)
